import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Slider from 'rc-slider'
import { updateFloorPlanAction, destroyFloorPlanAction } from 'actions/floorPlanActions'
import { notificationAction } from 'actions/notificationActions'
import clamp from 'ramda/src/clamp'

const mapStateToProps = ({ currentEntity, map: { floorPlans } }) => {
  return {
    currentFloorplan: currentEntity.type === 'floorPlan' && floorPlans.find(f => f.id === currentEntity.id)
  }
}

class FloorPlanDetails extends React.Component {
  render() {
    const { currentFloorplan, updateFloorPlanAction, destroyFloorPlanAction, notificationAction, classes } = this.props

    if (!currentFloorplan) return null

    const { id, locked, overlay, name, opacity } = currentFloorplan

    return (
      <div className={classes.floorPlanScaler}>
        <div className={classes.header}>
          Edit Floor Plan
        </div>
        <div className={classes.buttonsContainer}>
          <div
            onClick={_ => {
              if (locked) notificationAction('Cannot delete locked floor plan')
              else destroyFloorPlanAction(id)
            }}
            className={classes.deleteButton}
          >
            <FontAwesomeIcon icon={['far', 'trash-alt']} />
          </div>
          <div onClick={_ => overlay.map.fitBounds(overlay.getBounds())}>
            <FontAwesomeIcon icon='map-marker-alt' />
          </div>
          <div onClick={_ => updateFloorPlanAction(id, { locked: !locked })}>
            <FontAwesomeIcon icon={locked ? 'lock' : 'unlock'} />
          </div>
        </div>
        <div className={classes.row}>
          <span>Name:</span>
          <input
            type='text'
            className={classes.nameInput}
            onChange={ ({ target: { value } }) => updateFloorPlanAction(id, { name: value }) }
            value={name || `Floor Plan ${id}`}
          />
        </div>
        <div className={classes.row}>
          <span>Opacity</span>
          <div className={classes.sliderContainer}>
            <Slider
              min={0.5}
              max={1}
              value={clamp(0.5, 1, opacity || 1)}
              onChange={value => updateFloorPlanAction(id, { opacity: value })}
              step={0.05}
              marks={{ 0.5: '', 1: '' }}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, { updateFloorPlanAction, destroyFloorPlanAction, notificationAction })(injectSheet(style)(FloorPlanDetails))



// WEBPACK FOOTER //
// ./src/components/BottomBar/FloorPlanDetails/index.js